import type { World } from '../ecs/world'
import { PALETTE } from '../render/palette'

/** Auto-pickup on contact: food, keys, magic charges, treasure. */
export function pickupSystem(world: World, _dt: number): void {
  const t = world.tuning
  for (const p of world.players()) {
    for (const it of world.entities) {
      if (it.dead || it.kind !== 'pickup' || !it.pickup) continue
      const r = p.radius + it.radius + 2
      if ((p.x - it.x) ** 2 + (p.y - it.y) ** 2 >= r * r) continue
      const ps = p.player!
      switch (it.pickup.ptype) {
        case 'food': {
          // RATIONING dilutes each unit (floorMods.foodHealMul is 1 outside the directive)
          if (p.hp !== undefined && p.maxHp !== undefined) {
            const heal = t.food.heal * world.floorMods.foodHealMul
            const overflow = Math.max(0, p.hp + heal - p.maxHp)
            p.hp = Math.min(p.maxHp, p.hp + heal)
            // SURPLUS METABOLISM: wasted rations become a decaying shield
            if (overflow > 0 && world.amenities.has('metabolism')) {
              const m = t.amenities.metabolism
              p.shield = Math.min(m.shieldCap, (p.shield ?? 0) + overflow * m.convertRate)
            }
          }
          world.burst(it.x, it.y, PALETTE.food, 8, 90, 0.4)
          break
        }
        case 'key':
          ps.keys++
          world.bus.emit('key_pickup', {})
          world.burst(it.x, it.y, PALETTE.key, 8, 90, 0.4)
          break
        case 'magic':
          // charge cap includes any requisitioned EXPANDED AUTHORIZATION ranks
          if (ps.magic < t.player.maxMagic + world.mods.maxMagicBonus) ps.magic++
          world.burst(it.x, it.y, PALETTE.magic, 8, 90, 0.4)
          break
        case 'treasure':
          world.addScore(t.score.treasure)
          world.bus.emit('treasure', { value: t.score.treasure })
          world.burst(it.x, it.y, PALETTE.treasure, 10, 110, 0.5)
          break
        case 'archive':
          // fixed credit every time (deterministic per seed); which record the
          // profile receives is decided upstream in Game — persistence lives there
          world.addScore(t.score.archiveRecord)
          world.burst(it.x, it.y, PALETTE.archive, 12, 110, 0.6)
          break
        case 'armament': {
          // picking a new armament replaces any held one (no stacking)
          const id = it.pickup.armament ?? 'scatter'
          ps.armament = { id, charge: t.armaments[id].charge }
          world.bus.emit('armament_pickup', { id })
          world.burst(it.x, it.y, PALETTE.relay, 12, 120, 0.5)
          break
        }
      }
      it.dead = true
      world.bus.emit('pickup', { type: it.pickup.ptype })
    }
  }
}
